document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ custom-predictive.js loaded");

  const input = document.querySelector('#Search-In-Page');
  const resultsContainer = document.getElementById('predictive-search');

  if (!input || !resultsContainer) {
    console.warn("❌ Input or results container not found");
    return;
  }

  console.log("🔎 Found input and results container");

  let debounceTimeout;

  input.addEventListener('input', function () {
    const query = input.value.trim();
    console.log("⌨️ Input detected:", query);

    clearTimeout(debounceTimeout);

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      return;
    }

    debounceTimeout = setTimeout(() => {
      console.log("📡 Fetching suggestions for:", query);

      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&page=1&limit=4`)
        .then(response => response.json())
        .then(data => {
          console.log("📦 Suggestions returned:", data);
          let html = '';

          if (data.resources.collections.length > 0) {
            html += `<div class="predictive-search__result-group"><h3 class="predictive-search__heading">Collections</h3><ul class="predictive-search__results-list">`;
            data.resources.collections.forEach(col => {
              html += `<li class="predictive-search__item"><a class="predictive-search__item__link" href="${col.url}">${col.title}</a></li>`;
            });
            html += `</ul></div>`;
          }

          if (data.resources.products.length > 0) {
            html += `<div class="predictive-search__result-group"><h3 class="predictive-search__heading">Products</h3><ul class="predictive-search__results-list">`;
            data.resources.products.forEach(prod => {
              html += `<li class="predictive-search__item"><a class="predictive-search__item__link" href="${prod.url}">${prod.title}</a></li>`;
            });
            html += `</ul></div>`;
          }

          resultsContainer.innerHTML = html;
          resultsContainer.style.display = 'block';
        })
        .catch(err => {
          console.error('Search error:', err);
          resultsContainer.innerHTML = '';
        });
    }, 250);
  });
});